import React from 'react'

export default function Modalfullbookingrankteam() {
    return (
        <div>
            <div className='text-center'>
                <img src="./img/modal2.png" className="img-fluid" style={{ height: '150px' }}></img>
                <h5 className='fw-bold' style={{ color: '#2b2e5a' }}><i class="fa-solid fa-circle-exclamation" style={{ color: '#2b2e5a' }}></i> Opps...</h5>
                <div className='fw-bold' style={{ color: '#2b2e5a' }}>Jadwal Sudah Terisi</div>
                <div className='text-secondary'>
                    Jadwal rank team yang anda pilih sudah terisi dua team
                </div>

            </div>
        </div>
    )
}
